/** 数値の設定を共通化 */

// 縦断勾配
export const longitudinalSlope = {
	minValue: -999.999, // 最小値
	maxValue: 999.999, // 最大値
	decimalLength: 3, // 少数桁
	step: 0.001, // テキストボックスの上下キーで増減する値
};
